import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Col';
import { ReactComponent as HappyMealBoxSvg } from '../../assets/svg/happy-meal-box.svg';
import LanguageDropdown from '../LanguageDropdown.js';
import {withRouter} from 'react-router';
import VizSensor from 'react-visibility-sensor';
import {Link} from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { AnimationContext } from './Home';

export const formatText = string => {
  if (string) {
    return string.split('\n').map((text, index) => {
      const formatedText = ReactHtmlParser(createTextLinks(text));
      return (<React.Fragment key={`${text}-${index}`}>
        {formatedText}
        <br />
      </React.Fragment>)
    });
  }
}

export const createTextLinks = (text) => {
  return (text || "").replace(
    /([^\S]|^)(((https?:\/\/)|(www\.))(\S+))/gi,
    function (match, space, url) {
      var hyperlink = url;
      if (!hyperlink.match('^https?://')) {
        hyperlink = 'http://' + hyperlink;
      }
      return space + '<a href="' + hyperlink + '">' + url + '</a>';
    }
  );
}

class Legal extends Component {
  static contextType = AnimationContext;
  constructor(props) {
    super(props);
    this.state = {
      text: {},
      headerVisible: false,
      rightAlignLang: ['ara', 'heb'],
      lang: 'en'
    }
  }

  componentDidMount() {
    this.getTranslations();
    setTimeout(() => {
      this.context.setIntro(false);
      this.context.setshowStore(true);
    }, 2000);
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.getTranslations();
      const lang = this.props.match.params.id || 'en';
      this.setState({ lang });
    }
  }

  getTranslations() {
    let lang = 'en';
    if (this.props.match.params.id) {
      lang = this.props.match.params.id;
      this.setState({ lang });
    }
    try {
      const text = require(`../../data/legal/${lang}.json`);
      this.setState({ text });
    }
    catch (e) {
      const text = require(`../../data/legal/en.json`);
      this.setState({ text });
    }
  }

  render() {
    const { text, headerVisible, rightAlignLang, lang } = this.state;

    return (
      <div className="wrapper legal">
        {/* <Particles /> */}
        
        <div className={`sticky-header ${headerVisible ? 'fadeIn' : ''}`}>
          <Link to="/"><HappyMealBoxSvg /></Link>
          <LanguageDropdown url="/legal/" lang={lang} />
        </div>

        <Container>
          <VizSensor partialVisibility onChange={(isVisible) => {this.setState({ headerVisible: !isVisible }) }}>
          <Row>
            <Col className="header">
              <div className="logo">
                  <Link to="/"><HappyMealBoxSvg /></Link>
              </div>
                <LanguageDropdown url="/legal/" lang={lang} />
            </Col>
          </Row>
          </VizSensor>
  
          <Row dir={rightAlignLang.includes(lang) ? 'rtl' : 'ltr'} className={`content ${rightAlignLang.includes(lang) ? 'text-right' : ''}`}>
            <Col>
              <div className="section">
                <h2>{text.hsapp_parentsarea_screenname_legal}</h2>
                <h3>{text.hsapp_parentsarea_legal_header_2}</h3>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_1}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_1)}</p>
              </div>

              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_2}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_2)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_3}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_3)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_4}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_4)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_5}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_5)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_6}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_6)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_7}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_7)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_8}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_8)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_9}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_9)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_10}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_10)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_11}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_11)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_12}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_12)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_2_13}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_2_13)}</p>
              </div>
              <div className="section">
                <h3>{text.hsapp_parentsarea_legal_header_3}</h3>
                <h4>{text.hsapp_parentsarea_legal_header_3_1}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_1)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_3_2}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_2)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_3_3}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_3)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_3_4}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_4)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_3_5}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_5)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_3_6}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_6)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_3_7}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_7)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_3_8}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_8)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_3_9}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_9)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_3_10}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_10)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_3_11}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_11)}</p>
              </div>
              <div className="section">
                <h4>{text.hsapp_parentsarea_legal_header_3_12}</h4>
                <p>{formatText(text.hsapp_parentsarea_legal_text_3_12)}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default withRouter(Legal);